import {EquipmentCategory} from "../../../../model/Dto/Dict/EquipmentCategory";
import {ApiRequest, RequestMethod} from "../../../request";

const URL = "/api/equipment-category";

export async function getAllEquipmentCategories(): Promise<EquipmentCategory[]> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.GET);
    apiRequest.setUrl(URL);
    const response: any = await apiRequest.send();
    return response.data;
}